import { ARIAS } from '../utils/constants';

const MOBILE_BREAKPOINT = 640; // Tailwind sm breakpoint

// Generic modal initialization function
const initModal = (modalSelector, overlaySelector, closeBtnSelector, triggerSelector) => {
  const modal = document.querySelector(modalSelector);
  const overlay = document.querySelector(overlaySelector);
  const closeBtn = modal?.querySelector(closeBtnSelector);

  if (!modal || !closeBtn || !overlay) {
    return null; // Modal elements not found (could be intentional if metafield not set)
  }

  // Move modal and overlay to body to ensure proper fixed positioning
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
    document.body.appendChild(overlay);
  }

  // Ensure smooth transitions for the translate property
  modal.style.transition = 'translate 300ms ease-in-out';

  let handleEscape;

  const close = () => {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    // Reset translate property to hide modal
    if (isMobile) {
      modal.style.translate = '0 100%';
    } else {
      modal.style.translate = '100% 0';
    }

    modal.setAttribute(ARIAS.EXPANDED, 'false');
    overlay.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');

    document.removeEventListener('keydown', handleEscape);
    closeBtn.removeEventListener('click', close);
    overlay.removeEventListener('click', close);
  };

  const open = () => {
    handleEscape = (e) => {
      if (e.key === 'Escape') close();
    };

    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    // Use inline styles to override Tailwind classes and ensure proper positioning
    if (isMobile) {
      // Mobile: positioned at bottom, slides up
      modal.style.bottom = '0';
      modal.style.top = 'auto';
      modal.style.left = '0';
      modal.style.right = '0';
      modal.style.translate = '0 0';
    } else {
      // Desktop: positioned at right, slides in from right
      modal.style.top = '0';
      modal.style.bottom = 'auto';
      modal.style.right = '0';
      modal.style.left = 'auto';
      modal.style.translate = '0 0';
    }

    modal.setAttribute(ARIAS.EXPANDED, 'true');
    overlay.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');

    document.addEventListener('keydown', handleEscape);
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
  };

  // Use event delegation to handle dynamically added trigger buttons
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest(triggerSelector);
    if (trigger) {
      e.preventDefault();
      open();
    }
  });

  return { open, close };
};

const initProductStrengthModal = () => {
  // Initialize strength modal
  initModal(
    '[data-strength-modal-popup]',
    '[data-strength-modal-overlay]',
    '[data-strength-modal-close]',
    '[data-strength-modal-trigger]'
  );

  // Initialize frequency modal
  initModal(
    '[data-frequency-modal-popup]',
    '[data-frequency-modal-overlay]',
    '[data-frequency-modal-close]',
    '[data-frequency-modal-trigger]'
  );

  // Initialize consultation modal
  initModal(
    '[data-consultation-modal-popup]',
    '[data-consultation-modal-overlay]',
    '[data-consultation-modal-close]',
    '[data-consultation-modal-trigger]'
  );

  // Initialize file upload guide modal
  initModal(
    '[data-fileupload-modal-popup]',
    '[data-fileupload-modal-overlay]',
    '[data-fileupload-modal-close]',
    '[data-fileupload-modal-trigger]'
  );

  // Initialize expiry info drawer (account page)
  initModal(
    '[data-expiry-info-drawer]',
    '[data-expiry-info-overlay]',
    '[data-expiry-info-close]',
    '[data-expiry-info-trigger]'
  );
};

export default initProductStrengthModal;
